import RequestError from "../../api/RequestError";

class ResourceFetcher {
    /**
     * @param {string} baseurl 
     */
    constructor(baseurl) {
        this.baseurl = baseurl;
        
        while (this.baseurl.endsWith("/")) {
            this.baseurl = this.baseurl.substring(0, this.baseurl.length - 1);
        }
    }

    /**
     * Gets the given resource with an http request
     * @param {string} relativeResourcePath 
     */
    get(relativeResourcePath) {
        return fetch(this.getCompleteResourceUrl(relativeResourcePath))
            .then(response => {
                if (!response.ok)
                    throw new RequestError(response, `Response has status code ${response.status}`);
                return response;
            });
    }

    /**
     * Gets an image at the specified path. This is especially useful for getting the dimensions of the image.
     * @param {string} relativeResourcePath 
     * @returns {Promise<HTMLImageElement>}
     */
    getImage(relativeResourcePath) {
        return new Promise((resolve, reject) => {
            const img = new Image();

            img.onload = function() {
                resolve(img);
            };
            img.onerror = function (e) {
                reject(e);
            };

            img.src = this.getCompleteResourceUrl(relativeResourcePath);
        });
    }

    /**
     * Returns the complete and correct url for a resource
     * @param {string} relativeResourcePath 
     */
    getCompleteResourceUrl(relativeResourcePath) {
        return `${this.baseurl}/${relativeResourcePath}`;
    }
}

export default ResourceFetcher;